var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSmallOk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9 0a9 9 0 000 18A9 9 0 009 0zm6 7.202L7.893 14h-.569L3 9.831v-.546L4.706 7.65h.569l2.335 2.24L12.706 5h.57l1.705 1.636c.019.214.019.352.019.566z",
    id: "icon_small_ok_svg__a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#5CB85C",
    xlinkHref: "#icon_small_ok_svg__a",
    fillRule: "evenodd"
  })));
}
export default SvgIconSmallOk;